import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M3.74085 4.97282L0.773951 1.91719C0.630904 1.76988 0.630904 1.5309 0.773951 1.38358L1.12004 1.02715C1.26294 0.879993 1.49438 0.879837 1.63758 1.02653L3.99992 3.44823L6.36242 1.02668C6.50562 0.879836 6.73706 0.880151 6.87995 1.02731L7.22605 1.38374C7.36909 1.53105 7.36909 1.77003 7.22605 1.91735L4.259 4.97282C4.11595 5.12014 3.8839 5.12014 3.74085 4.97282Z"
      fill="white"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const WhiteDownArrow = memo(ForwardRef);
export default WhiteDownArrow;
